import { action, extendObservable } from 'mobx';
import PropTypes from 'prop-types';
import InputStore from './InputStore';

export default class FuseSearchTextStore {
    static PropType = PropTypes.shape({
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        inputStore: InputStore.PropType,
        searchCount: PropTypes.number,
        searchIndex: PropTypes.number,
        searchBack: PropTypes.func,
        searchForward: PropTypes.func,
        focus: PropTypes.bool,
        hover: PropTypes.bool,
        disabled: PropTypes.bool,
        readOnly: PropTypes.bool,
        placeholder: PropTypes.string,
        onChangeHandler: PropTypes.func,
        setValue: PropTypes.func,
    });

    constructor(data = {}) {
        this.placeholder = 'Find Results';
        extendObservable(this, /** @class FuseSearchTextStore */{
            inputStore: new InputStore(),
            searchCount: 0,
            searchIndex: 0,
        }, data);
    }

    setSearchValue = action((newValue) => {
        this.inputStore.setValue(newValue);
    });

    setSearchIndex = action((index) => {
        this.searchIndex = index;
    });

    setSearchCount = action((index) => {
        this.searchCount = index;
    });
}
